var fantasyFootballBaseSetBuilder_nextBaseId = 0;
var fantasyFootballBaseSetBuilder_productIdList;
var fantasyFootballBaseSetBuilder_labels;
var fantasyFootballBaseSetBuilder_originalAdd1Button_text;
var fantasyFootballBaseSetBuilder_headerPlayerCount_html;
var fantasyFootballBaseSetBuilder_colorOptions;
var fantasyFootballBaseSetBuilder_predefinedSets = 
  {    
    "standard": [      
      ["white", "32", 1],
      ["white", "32", 2],       
      ["red", "32", 3],
      ["red", "32", 4],       
      ["red", "32", 5],
      ["red", "32", 6],      
      ["green", "32", 7],
      ["green", "32", 8],
      ["yellow", "32", 9],
      ["yellow", "32", 10],
      ["blue", "32", 11],
      ["blue", "40", 12],        
      ["gray", "32", 13],
      ["gray", "32", 14],
      ["gray", "32", 15],
      ["gray", "32", 16],       
      ["purple", "32", 17],
      ["orange", "32", 'star']
    ],
    "extended":  [      
      ["white", "32", 1],
      ["white", "32", 2],       
      ["red", "32", 3],
      ["red", "32", 4],       
      ["red", "32", 5],
      ["red", "32", 6],       
      ["yellow", "32", 7],
      ["yellow", "32", 8],
      ["yellow", "32", 9],
      ["yellow", "32", 10],       
      ["blue", "32", 11],
      ["blue", "32", 12],     
      ["blue", "40", 11],
      ["blue", "40", 12],        
      ["green", "32", 5],
      ["green", "32", 6],      
      ["green", "32", 7],
      ["green", "32", 8],
      ["green", "32", 9],
      ["green", "32", 10],
      ["gray", "32", 13],
      ["gray", "32", 14],
      ["gray", "32", 15],
      ["gray", "32", 16],       
      ["purple", "32", 17],
      ["purple", "32", 18],
      ["purple", "32", 19],
      ["purple", "32", 20],
      ["orange", "32", 'star']
    ],
    "journeymen":  [ 
      ["purple", "32", 17],
      ["purple", "32", 18],
      ["purple", "32", 19],
      ["purple", "32", 20]
    ],
  };

const fantasyFootballBaseSetBuilder_maximumBaseCount = 30;

var initializeFantasyFootballBaseSetBuilder = function (productIdList, labels) {
  const addToCartButton = $('#addToCartButton');
  const addButton = $('#add1Button');
  $('.ff-set-bottom-section > *').removeClass("hidden");
  fantasyFootballBaseSetBuilder_originalAdd1Button_text = addButton.text();
  fantasyFootballBaseSetBuilder_productIdList = productIdList;
  fantasyFootballBaseSetBuilder_labels = labels;
  fantasyFootballBaseSetBuilder_headerPlayerCount_html = $('.ff-set-header-player-count').html();
 
  $('#clearAllButton').on('click', () =>
    {
      fantasyFootballBaseSetBuilder_removeAll();
    });
  
  addButton.on("click", () => 
    {
      fantasyFootballBaseSetBuilder_addBase(false);
    });
  addToCartButton.on("click", () =>
    {
      fantasyFootballBaseSetBuilder_addToCart();
    });
  fantasyFootballBaseSetBuilder_updateControls();

  fantasyFootballBaseSetBuilder_colorOptions = '';
  for (const color in TTG.Resources.Strings.ColorNames) {
    fantasyFootballBaseSetBuilder_colorOptions += `<option value='${color}'>${TTG.Html.encodeHtml(TTG.Resources.Strings.ColorNames[color])}</option>`;
  }
  
  TTG.UI.initializeModal("#addPredefinedSetDialog");
   TTG.UI.initializeModal("#addedToCartDialog");
  
  $("#addPresetButton").on("click", () => {
    TTG.UI.showModal("#addPredefinedSetDialog");
  });
  $("#addPredefinedSetDialog_cancelButton").on("click", () => {
    TTG.UI.hideModal("#addPredefinedSetDialog");
  });
  $("#addedToCartDialog_continueButton").on("click", () => {
    TTG.UI.hideModal("#addedToCartDialog");
  });
  $("#addedToCartDialog_goToCartButton").on("click", () => {
    window.location.href = "/cart";
  });
  
  $('.ff-base-set-predefined-button').on("click", (e) =>
    {
       const setId = $(e.target).attr("data-set-id");
      fantasyFootballBaseSetBuilder_addPredefinedSetById(setId);
    })
}

var fantasyFootballBaseSetBuilder_removeAll = function()
  {
    const existingBases = $('.ff-base:not(.ff-base-empty)');
    existingBases.remove();
    fantasyFootballBaseSetBuilder_updateControls();
  }

var fantasyFootballBaseSetBuilder_addPredefinedSetById = function(setId)
  {
    const set = fantasyFootballBaseSetBuilder_predefinedSets[setId];
    for(let i = 0; i < set.length; i++)
      {
          const base = set[i];
        fantasyFootballBaseSetBuilder_addBase(true, base[0], base[1], base[2]);
      }
        fantasyFootballBaseSetBuilder_updateControls();
        TTG.UI.hideModal("#addPredefinedSetDialog");
  }



var fantasyFootballBaseSetBuilder_removeBaseById = function(baseId)
{
  const base = $(`.ff-base[data-base-id=${baseId}]`);
  base.remove(); 
  fantasyFootballBaseSetBuilder_updateControls();
}

var fantasyFootballBaseSetBuilder_updateBaseById = function(baseId)
{
  const base = $(`.ff-base[data-base-id=${baseId}]`);
  const label =  base.find('.ff-base-label');
  const color = base.find('.ff-base-color-selector').val();
  const number = base.find('.ff-base-number-selector').val();
  const size = base.find('.ff-base-size-selector').val();
  base.attr("data-background-color", color);
  base.attr("data-number", number);
  base.attr("data-size", size);
   
  if(String(number) === 'star')
  {
    if(color === 'white')
    {
    label.html("<img src='https://tabletopgoodiescdn.blob.core.windows.net/store/icons/512x512/star_black.png' src='*' width='23px' height='23px' />")
    }
    else{
    label.html("<img src='https://tabletopgoodiescdn.blob.core.windows.net/store/icons/512x512/star_white.png' src='*' width='23px' height='23px' />")
    }
  }
  else{
    label.text(number);
  }
}

var fantasyFootballBaseSetBuilder_updateControls = function()
{
  const header = $('.ff-set-header');
  const addToCartSection = $('.ff-base-set-add-to-cart-section');
  const addToCartButton = $('#addToCartButton');
  const bases = $('.ff-base');
   const set = $('.ff-set');
  const emptyBase = $('.ff-base.ff-base-empty');
  const addButton = $('#add1Button');
  const addSection = $('.ff-set-bottom-section');

  const baseCount = bases.length - 1;
  set.attr("data-base-count", baseCount)
  if(baseCount == 0 || TTG.Numbers.isEven(baseCount))
  {
    emptyBase.addClass("hidden");
  }
  else {
    emptyBase.removeClass("hidden");
  }

  if(baseCount == 0)
  {
    header.addClass("hidden");
    addToCartSection.addClass("hidden");
    addButton.text(fantasyFootballBaseSetBuilder_originalAdd1Button_text);
  }
  else{
    $('.ff-set-header-player-count').html(TTG.formatStringWithObject(fantasyFootballBaseSetBuilder_headerPlayerCount_html,
                                                                     {
                                                                       player_count: baseCount
                                                                     }));
    header.removeClass("hidden");
    addToCartSection.removeClass("hidden");
    addButton.text(fantasyFootballBaseSetBuilder_labels.AddExtraBaseButton);
    if(baseCount == 1)
    {
      addToCartButton.text(fantasyFootballBaseSetBuilder_labels.AddToCartOneBase);
    }
    else{
      addToCartButton.text(TTG.formatStringWithObject(fantasyFootballBaseSetBuilder_labels.AddToCartMoreThanOneBases,
                                                      {
                                                        base_count: baseCount
                                                      }));
    }
  }  
  if(baseCount >= fantasyFootballBaseSetBuilder_maximumBaseCount)
  {
    addSection.hide();
  }
  else{
    addSection.show();
  }
}
  
var fantasyFootballBaseSetBuilder_addBase = function(predefined, specifiedColor, specifiedSize, specifiedNumber)
{
  fantasyFootballBaseSetBuilder_nextBaseId++;
  const id = fantasyFootballBaseSetBuilder_nextBaseId;
  const bases = $('.ff-bases');
  const emptyBase = $('.ff-base.ff-base-empty');
  emptyBase.detach();

  let color;
  let number = 0;
  let size;

  if(!predefined)
  {
    let lastColor = 'red';
    let lastSize = '32';
    let lastNumber = 0;
    const existingBases = $('.ff-base:not(.ff-base-empty)');
     
    for(let i = 0; i < existingBases.length; i++)
    {
      const existingBase = $(existingBases.get(i));
      const numberSelect = existingBase.find('.ff-base-number-selector');
      const sizeSelect = existingBase.find('.ff-base-size-selector');
      const colorSelect = existingBase.find('.ff-base-color-selector');
      let value = numberSelect.val();
      value = Number(value);
      if(!isNaN(value))
      {
        if(value > number) number = value;
        lastNumber = value;
      }
      lastSize = sizeSelect.val();
      lastColor = colorSelect.val();
    }

    number = lastNumber;
    number++;
      
    if(number > 25)
    {
      number = 'star';
    }
  
    color = lastColor;
    size = lastSize;
  }
  else{
    color = specifiedColor;
    size = specifiedSize;
    number = specifiedNumber;
  }

  
  var section = `
    <div class="ff-base product-color-background-container" data-base-id='${id}'>
        <div class="ff-base-label product-color-background">1</div>
      <div class="ff-base-color">
        <div class="select">
          <select
            required
            id=""
            class="select__select ff-base-color-selector"
          >
           ${fantasyFootballBaseSetBuilder_colorOptions}
          </select>
        </div>
      </div>
      <div class="ff-base-size">
        <div class="select">
          <select
            required
            id=""
            class="select__select ff-base-size-selector"
          >
            <option value="25">25mm</option>
            <option value="32">32mm</option>
            <option value="40">40mm</option>
          </select>
        </div>
      </div>
      <div class="ff-base-number">
        <div class="select">
          <select
            required
            class="select__select ff-base-number-selector"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="star">${fantasyFootballBaseSetBuilder_labels.Star}</option>
          </select>
        </div>
      </div>
      <div class="ff-base-actions">
        <button style="color:gray;font-weight:bold" class="ttg-button wide ff-base-remove-button">
          <img src='https://tabletopgoodiescdn.blob.core.windows.net/store/icons/512x512/recyclebin_black.png' src='*' width='23px' height='23px' />
        </button>
      </div>
    </div>`;

  section = $(section);
  section.find('.ff-base-number-selector').val(number);
  section.find('.ff-base-color-selector').val(color);
  section.find('.ff-base-size-selector').val(size);
  
  section.find('select').on("change", (e) =>
    {
      const b = $(e.target);
      const base = b.closest(".ff-base");
      fantasyFootballBaseSetBuilder_updateBaseById(Number(base.attr("data-base-id")));
    });
  
  section.find('.ff-base-remove-button').on("click", (e) =>
    {
      const b = $(e.target);
      const base = b.closest(".ff-base");
      fantasyFootballBaseSetBuilder_removeBaseById(Number(base.attr("data-base-id")));
    });
  bases.append(section);
  bases.append(emptyBase);
  fantasyFootballBaseSetBuilder_updateBaseById(id);
  if(!predefined)
  {
    fantasyFootballBaseSetBuilder_updateControls();
  } 
}

var fantasyFootballBaseSetBuilder_addBasesToCartData = function(data, size, productId, uniqueId)
  {
    const bases = $(`.ff-base[data-size=${size}]`);
    if(bases.length > 0)
    {
      const properties = {
        "_type": "FFBaseSet",
        "_unique_id": uniqueId,
        "_fixed_quantity" : bases.length        
      };
      let players = '';
      for(let i = 0; i < bases.length; i++)
      {
        const base = $(bases.get(i));
        if(players != '') players += ", ";
        players += `${base.attr('data-number')}/${TTG.Resources.Strings.ColorNames[base.attr("data-background-color")]}`
      }
      properties["Bases"] = players;
      const item = 
      {
        id: Number(productId),
        quantity: bases.length,
        properties : properties
      };
      data.items.push(item);
    }
    return bases.length;
  }

var fantasyFootballBaseSetBuilder_addToCart = function()
  {

    const uniqueId = "SET-" + TTG.Strings.generateRandomString(5);
    
    const addToCartButton = $('#addToCartButton');
    addToCartButton.attr("disabled", "disabled");
    
    const formData = {
      items : []
    };

    let total = 0;
    total += fantasyFootballBaseSetBuilder_addBasesToCartData(formData, "25", fantasyFootballBaseSetBuilder_productIdList.base25mm, uniqueId);
    total += fantasyFootballBaseSetBuilder_addBasesToCartData(formData, "32", fantasyFootballBaseSetBuilder_productIdList.base32mm, uniqueId);
    total += fantasyFootballBaseSetBuilder_addBasesToCartData(formData, "40", fantasyFootballBaseSetBuilder_productIdList.base40mm, uniqueId);
    
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        const title = $("#addedToCartDialog .modal-dialog-title");
        var text = title.attr("data-text-one");
        
        if (total > 1) {
          text = TTG.formatStringWithObject(title.attr("data-text-more-than-one"), {
            base_count: String(total),
          });
        }
        title.text(text);
        TTG.UI.showModal("#addedToCartDialog");
        addToCartButton.removeAttr("disabled");
      })
      .catch((error) => {
        console.error("There was an error adding the item to the cart:", error);
      });
  
  }